import { Link } from "react-router-dom";
import { ArrowUpRight, TrendingUp, BarChart3, Smartphone, ShoppingBag } from "lucide-react";

const PROJECTS = [
  {
    brand: "Wellnest Naturals",
    category: "Beauty & Wellness",
    metric: "₹0 → ₹1.2Cr GMV",
    timeframe: "9 months",
    icon: TrendingUp,
    tags: ["Amazon FBA", "Brand Registry", "PPC"],
    accent: "#FF9900",
  },
  {
    brand: "Avani Apparel",
    category: "Fashion",
    metric: "Myntra approval in 3 weeks · ₹40L Q1",
    timeframe: "Quarter 1",
    icon: ShoppingBag,
    tags: ["Myntra", "Nykaa Fashion", "Studio Catalog"],
    accent: "#FF3F6C",
  },
  {
    brand: "BrewBox Coffee",
    category: "Quick Commerce",
    metric: "4× sell-through week one on Blinkit",
    timeframe: "Week 1",
    icon: BarChart3,
    tags: ["Blinkit", "Zepto", "SKU Strategy"],
    accent: "#F8CB46",
  },
  {
    brand: "Nuvi Skincare",
    category: "D2C + Marketplace",
    metric: "Account reinstated in 6 days · saved Q4",
    timeframe: "6 days",
    icon: TrendingUp,
    tags: ["Amazon Appeal", "Compliance", "Account Health"],
    accent: "#2D2D2D",
  },
  {
    brand: "Forge Footwear",
    category: "Fashion Tech",
    metric: "ROAS 3.8× · Weekly P&L per channel",
    timeframe: "Ongoing",
    icon: BarChart3,
    tags: ["Reporting", "Ads", "Multi-channel"],
    accent: "#2874F0",
  },
  {
    brand: "GreenStem Plants",
    category: "Home & Garden",
    metric: "3× Q4 revenue · JioMart festive deals",
    timeframe: "Quarter 4",
    icon: Smartphone,
    tags: ["JioMart", "Festive", "Catalog"],
    accent: "#008ECC",
  },
];

export default function ProjectsSection() {
  return (
    <section
      data-testid="projects-section"
      className="bg-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="eyebrow">Projects & Case Studies</div>
            <h2 className="display mt-3 text-4xl font-black tracking-tight md:text-5xl lg:text-6xl">
              Brands we've shipped.
            </h2>
          </div>
          <p className="max-w-md text-base text-black/70">
            A snapshot of brands we've launched, scaled and turned around across India's biggest marketplaces.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-0 md:grid-cols-2 lg:grid-cols-3">
          {PROJECTS.map((p, i) => (
            <div
              key={p.brand}
              data-testid={`project-${i}`}
              className="group relative -ml-[2px] -mt-[2px] flex flex-col border-2 border-black bg-white transition-all hover:bg-[#FFD700]"
            >
              {/* Accent bar */}
              <div className="h-2 w-full" style={{ background: p.accent }} />

              <div className="flex flex-1 flex-col p-7">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-[10px] font-bold uppercase tracking-widest text-black/60">
                      {p.category}
                    </div>
                    <h3 className="display mt-2 text-2xl font-black tracking-tight md:text-3xl">
                      {p.brand}
                    </h3>
                  </div>
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center border-2 border-black bg-[#FFD700] group-hover:bg-black group-hover:text-[#FFD700]">
                    <p.icon size={16} />
                  </div>
                </div>

                <div className="mt-6 border-t-2 border-black pt-5">
                  <div className="text-[10px] font-bold uppercase tracking-widest text-black/50">
                    Outcome
                  </div>
                  <div className="display mt-1 text-lg font-black leading-tight text-black md:text-xl">
                    {p.metric}
                  </div>
                  <div className="mt-2 text-xs font-bold text-black/60">{p.timeframe}</div>
                </div>

                <div className="mt-5 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="border-2 border-black bg-white px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide group-hover:bg-black group-hover:text-[#FFD700]"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/contact/?type=case-study"
            className="btn-brutal"
            data-testid="projects-cta"
          >
            Become the next case study <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>
    </section>
  );
}
